import React, { useState, useEffect } from "react";
import Login from "./component/Login";
import Home from "./component/Home";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import SetCredentials from "./component/SetCredentials";
import AuthProvider from "./context/AuthContext";
import { AuthContext } from "./context/AuthContext";
import Dashboard from "./screen/dashboard/Dashboard";
import DataTable from "./screen/dashboard/DataTable";
import HeaderCompo from "./component/Header";
import DataTableGpr from "./screen/dashboard/DataTableGpr";
import { useSelector, useDispatch } from "react-redux";
import Users from "./screen/dashboard/Users";
import Accounts from "./screen/dashboard/Accounts";
import DashboardGpr from "./screen/dashboard/DashboardGpr";
import { BE_HOST } from "./config/config";
import axios from "axios";
import { userAuthAction } from "./redux/action/authAction";
import ProductDetails from "./screen/dashboard/ProductDetails";
import ProductCatalog from "./screen/dashboard/ProductCatalog";
import GLP1ManagementScreen from "./screen/dashboard/GLP1ManagementScreen";
import ReactNewDashboard from "./screen/dashboard/NewDashboard";
import SessionReports from "./screen/reports/SessionReports";
import SftpLogs from "./screen/dashboard/SftpLogs";
import MobileAuth from "./screen/authentication/MobileAuth";
import ResetPassword from "./screen/authentication/ResetPassword";
import ForgotPassword from "./screen/authentication/ForgotPassword";
import Otp from "./screen/authentication/Otp";
import EmailVerification from "./screen/authentication/EmailVerification";
import ResetPasswordNew from "./screen/authentication/ResetPasswordNew";
import AdminChats from "./screen/adminchats/AdminChats";
import AutomationDashboard from "./screen/automation/AutomationDashboard";
import AuditLogs from "./screen/automation/logs/AuditLogs";
import SmsWorkflow from "./screen/smsWorkflow/SmsWorkflow";
import SmsWorkflowNotification from "./components/smsWorkflowNotification/SmsWorkflowNotification";
import ChatDashboard from "./screen/chatDashboard/ChatDashboard";
import PowerBiSales from "./screen/powerBiSales/PowerBiSales";
// import AdvantageAnalysis from "./screen/powerBiSales/AdvantageAnalysis";
import DataDictionary from "./screen/dataDictionary/DataDictionary";
import CPTSettings from "./screen/cptSettings/CPTSettings";
import Supplier from "./screen/supplier/supplierMain/Supplier";
import EmailReport from "./screen/emailReport/EmailReport";
import RebateStatement from "./screen/rebate/RebateStatement";
import ChatHistory from "./screen/chatHistory/ChatHistory";

function App() {
  // const { isAuthenticated } = useContext(AuthContext);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const dispatch = useDispatch();
  const token = useSelector((state) => state.userAuth.token);
  // const userAuth = useSelector((state) => state.userAuth);
  const [initialColor, setIntialColor] = useState("#000833");
  const userAuth = useSelector((state) => state.userAuth.decodedToken);
//   const redirectUrl = encodeURIComponent(
//   window.location.pathname + window.location.search
// );

  // const isAuthenticated = true
  // console.log("tokentokentoken", token);
  // console.log("userAuth", userAuth);

  // console.log(token, "tokennnnnn")

  const handleColorChange = (color) => {
    setIntialColor(color);
  };


  // useEffect(() => {
  //   const loc = JSON.parse(localStorage.getItem("userInfo") || null);
  //   setIsAuthenticated(loc);
  // }, [isAuthenticated, userAuth]);

  const isLoggedIn = token?.token;
  // console.log(isLoggedIn,"isLoggedInisLoggedIn")
  return (
    <Router>
      {/* {isLoggedIn ? <HeaderCompo initialColor={initialColor} /> : null} */}
      <Routes>
        {!isLoggedIn && (
          <>
            <Route
              exact
              path="/"
              element={
                // isLoggedIn ? <Dashboard /> : <Navigate to={`/login?redirect=${redirectUrl}`}
                // replace />
                isLoggedIn ? <Dashboard /> : <Navigate to="/login" replace />
              }
            />
            
            <Route path="/login" element={<Login />} />
            <Route exact path="/set" element={<SetCredentials />} />

            <Route exact path="/forgot" element={<ForgotPassword />} />

            {/* <Route exact path="/verify-and-set-password" element={<ResetPasswordNew />} />
            <Route exact path="/reset-password" element={<ResetPassword />} /> */}
            <Route path="*" element={<Navigate to="/" replace />} />,
            <Route exact path="/verify-email" element={<EmailVerification />} />
            {userAuth && (
              <>
                {/* <Route exact path="/reset-password" element={<ResetPassword />} /> */}
                <Route exact path="/MobileAuth" element={<MobileAuth />} />
                <Route exact path="/otp" element={<Otp />} />
              </>
            )}
          </>
        )}
        <Route exact path="/verify-and-set-password" element={<ResetPasswordNew />} />
            <Route exact path="/reset-password" element={<ResetPassword />} />
            <Route
              path="/chat-dashboard"
              element={<ChatDashboard handleColorChange={handleColorChange} />}
            />

        {isLoggedIn && (
          <>
            {/* <Route exact path="/MobileAuth" element={<MobileAuth />} /> */}
            {/* <Route exact path="/reset-password" element={<ResetPassword />} /> */}
            {/* <Route exact path="/otp" element={<Otp />} /> */}
            <Route path="/home" element={<Home />} />,
            <Route path="/dashboard_old" element={<DashboardGpr />} />,
            <Route path="/react-dashboard" element={<ReactNewDashboard />} />,
            <Route path="/data_table_gcr" element={<DataTable />} />,
            <Route path="/data_table_gpr" element={<DataTableGpr />} />,
            <Route path="/users" element={<Users />} />,
            <Route path="/accounts" element={<Accounts />} />,
            <Route
              path="/product-catalogue"
              element={<ProductCatalog handleColorChange={handleColorChange} />}
            />
            <Route
              path="/admin-chat"
              element={<AdminChats handleColorChange={handleColorChange} />}
            />
            <Route path="/session-reports" element={<SessionReports />} />
            <Route
              path="/glp1-management"
              element={
                <GLP1ManagementScreen handleColorChange={handleColorChange} />
              }
            />
            <Route
              path="/react-dashboard"
              element={
                <ReactNewDashboard handleColorChange={handleColorChange} />
              }
            />
            <Route
              path="/product-details"
              element={<ProductDetails handleColorChange={handleColorChange} />}
            />
            <Route
              path="/sftp-logs"
              element={<SftpLogs handleColorChange={handleColorChange} />}
            />
            <Route
              path="/automation-dashboard"
              element={<AutomationDashboard handleColorChange={handleColorChange} />}
            />
             <Route
              path="/sms-workflow"
              element={<SmsWorkflow handleColorChange={handleColorChange} />}
            />
            <Route
              path="/sms-config"
              element={<SmsWorkflowNotification handleColorChange={handleColorChange} />}
            />
            <Route
              path="/automation-audit-log"
              element={<AuditLogs handleColorChange={handleColorChange} />}
            />
            {/* <Route
              path="/chat-dashboard"
              element={<ChatDashboard handleColorChange={handleColorChange} />}
            /> */}
            <Route
              path="/powerbi-sales"
              element={<PowerBiSales handleColorChange={handleColorChange} />}
            />
            {/* <Route
              path="/advantage-analysis"
              element={<AdvantageAnalysis handleColorChange={handleColorChange} />}
            /> */}
            <Route
              path="/data-dictionary"
              element={<DataDictionary handleColorChange={handleColorChange} />}
            />
            <Route
              path="/cpt-settings"
              element={<CPTSettings handleColorChange={handleColorChange} />}
            />
            {/* <Route
              path="/supplier"
              element={<Supplier handleColorChange={handleColorChange} />}
            /> */}
             <Route
              path="/email-report"
              element={<EmailReport handleColorChange={handleColorChange} />}
            />
            <Route
              path="/rebate-statement"
              element={<RebateStatement handleColorChange={handleColorChange} />}
            />
            <Route
              path="/chat-history"
              element={<ChatHistory handleColorChange={handleColorChange} />}
            />
            <Route path="*" element={<ReactNewDashboard />} />,
          </>
        )}


      </Routes>
    </Router>
  );
}

export default App;
